// Detectează că pe server a apărut o versiune nouă a interfeței (după o actualizare), cât timp pagina
// rămâne deschisă cu fișierele vechi. Compară fișierul principal încărcat (main.<hash>.js) cu cel din
// index.html de pe server. La dezvoltare (fișier fără hash) nu face nimic.
const loadedMain = () => {
  for (const s of document.scripts) {
    const m = (s.src || "").match(/\/static\/js\/(main\.[0-9a-f]+\.js)/);
    if (m) return m[1];
  }
  return null;
};

export async function newVersionAvailable() {
  const mine = loadedMain();
  if (!mine) return false;
  try {
    const r = await fetch("/index.html?_=" + Date.now(), { cache: "no-store" });
    const m = (await r.text()).match(/\/static\/js\/(main\.[0-9a-f]+\.js)/);
    return !!m && m[1] !== mine;
  } catch { return false; }
}
